import Archive from "./Archive";
import Global from "./Global";
import Header from "./Header";
import Single from "./Single";

const app = {
  init: () => {
    console.log("~/Hemsa");

    console.log(
      "Font Awesome Free 7.2.0 by @fontawesome - https://fontawesome.com",
    );
    console.log(
      "License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)",
    );
    console.log("Copyright 2026 Fonticons, Inc.");

    Global.init();
    Header.init();
    Archive.init();
    Single.init();
  },
};

document.readyState === "loading"
  ? document.addEventListener("DOMContentLoaded", app.init)
  : app.init();
